<template>
  <div class="container">

    <h1 v-if="invitation.auctionInvitationRole === auctionInvitationRoles.SELLING_AGENT.value">Join Auction as a Selling Agent</h1>
    <h1 v-else-if="invitation.auctionInvitationRole === auctionInvitationRoles.BUYER_OBSERVER.value">Join Auction as a Buyer Observer</h1>
    <h1 v-else-if="invitation.auctionInvitationRole === auctionInvitationRoles.BUYER.value">Join Auction as a Buyer</h1>
    <h1 v-else-if="invitation.auctionInvitationRole === auctionInvitationRoles.SELLER.value">Join Auction as a Seller</h1>
    <h1 v-else>Join Auction</h1>

    <div v-if="$store.state.authenticatedUser === null">
      <InlineSpinner />
    </div>

    <div v-else-if="$store.state.authenticatedUser === false">
      <p>You've been invited to a property auction, but you need to first sign up and login to complete this process.</p>
      <p><button @click.prevent="openLoginDialog">Login</button></p>
    </div>

    <div v-else-if="$store.state.authenticatedUser === true">

      <div v-if="invitation.id">
        <p>
          You've been invited to an auction of the following property:<br/>
          <span class="big">{{ invitation.target.address }}, {{ invitation.target.city }}, {{ invitation.target.state }}</span>
        </p>

        <p v-if="invitedByProfile.email">
          Invitation is sent by:<br/>
          <span class="big">{{ invitedByProfile.firstName }} {{ invitedByProfile.lastName }} ({{ invitedByProfile.email }})</span>
        </p>

        <p>
          You are currently logged in as:<br/><strong>{{ $store.state.user.profile.email }}</strong>.
        </p>

        <p>
          In order to proceed this you should have received an invitation link and token via email.
          Please enter the token to the input field below (if it's not prefilled automatically) and click the join button.
        </p>
        <form ref="joinForm">
          <fieldset>
            <label for="token">Token</label>
            <input v-model="token" id="token" type="text" required />
          </fieldset>
          <fieldset>
            <button class="wider" @click.prevent="join" v-if="$store.state.authenticatedUser">Join</button>
            <button class="wider" disabled v-else>Join</button>
          </fieldset>
        </form>
      </div>

      <div v-else-if="notFound">
        The provided token {{ token }} has either already been used, or it is otherwise not valid.
      </div>

      <div v-else>
        <InlineSpinner />
      </div>

      <p v-if="notificationText"><v-icon color="red">error</v-icon> {{ notificationText }}</p>
    </div>

  </div>
</template>

<script>
  import InlineSpinner from './elements/InlineSpinner.vue'
  import { auctionInvitationRoles } from '../utils/PfxUtils.js'

  export default {
    name: 'JoinAuctionPage',
    components: {
      InlineSpinner
    },
    data() {
      return {
        auctionInvitationRoles,
        token: this.$route.params.token,
        invitation: {},
        notFound: false,
        notificationText: '',
        invitedByProfile: {}
      }
    },
    computed: {
      authenticatedUser() {
        return this.$store.state.authenticatedUser
      }
    },
    watch: {
      authenticatedUser() {
        this.getInvitation()
      }
    },
    created() {
      this.getInvitation()
    },
    methods: {
      openLoginDialog() {
        this.$store.commit('openLoginDialog')
      },
      getInvitation() {
        if (this.$store.state.authenticatedUser) {
          this.$PfxBackendApi.getAuctionInvitation(this.token).then(res => {
            console.log('getAuctionInvitation res', res)
            const invitation = res.data || {}
            const invitedByUserId = invitation.invitedBy

            this.$PfxBackendApi.getUser(invitedByUserId).then(res => {
              console.log('getUser res', res)
              this.invitedByProfile = res.data || {}
            }).catch(err => {
              console.error('getUser err', err)
              this.invitedByProfile = {}
            }).then(() => {
              this.invitation = invitation
            })

          }).catch(err => {
            console.error('getAuctionInvitation error', err)
            this.notFound = true
          })
        }
      },
      join() {
        if (!this.$refs.joinForm.checkValidity()) {
          this.$refs.joinForm.reportValidity()
          return
        }
        if (!this.$store.state.user.idToken) {
          this.openSignUpDialog()
          return
        }

        this.$store.state.loadingSpinner = true
        const auctionId = this.invitation.target.id
        this.$PfxBackendApi.useAuctionInvitation(auctionId, this.token).then(res => {
          console.log('useAuctionInvitation res', res)
          this.token = ''
          this.$store.state.loadingSpinner = false
          this.$router.push('/auction/' + auctionId)
        }).catch(err => {
          console.error('useAuctionInvitation error', err)
          if (err.status === 409) {
            this.notificationText = 'Error, you are already part of this auction in some role.'
          } else {
            this.notificationText = 'Error, status ' + (err.status || -1)
          }
          this.$store.state.loadingSpinner = false
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

  .big {
    font-weight: 600;
    font-size: 1.2rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/JoinAuctionPage.vue